<style lang="scss">
@media screen and (min-width: 55rem) {
  .homepage-number-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
    height: 12rem;
    .homepage-number {
      max-width: 1080px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .homepage-number-list {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .homepage-number-item {
          width: 18rem;
          margin-left: 1rem;
          height: 8rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .num {
            font-family: Helvetica Bold;
            font-size: 2.6rem;
            font-weight: bolder;
            color: #000000;
          }
          .numhidden {
            font-size: 1.2rem;
            font-family: "PingFang SC", "Microsoft YaHei";
            font-weight: normal;
            color: #000000;
            
          }
        }
        .homepage-number-item-line {
        }
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .homepage-number-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;

    height: auto;
    .homepage-number {
      width: 80%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .homepage-number-list {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        .homepage-number-item {
          width: 40%;
          margin-left: 1rem;
          height: 8rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .num {
            font-family: Helvetica Bold;
            font-size: 2.2rem;
            font-weight: bolder;
            color: #000000;
          }
          .numhidden {
            font-size: 0.8rem;
            font-family: "PingFang SC", "Microsoft YaHei";
            font-weight: normal;
            color: #000000;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="homepage-number-container">
    <div class="homepage-number">
      <div class="homepage-number-list">
        <div class="homepage-number-item">
          <div class="num">1998</div>
          <div class="numhidden">第一家店杭州武林银泰开业</div>
        </div>
        <div class="homepage-number-item-line"></div>
        <div class="homepage-number-item">
          <div class="num">500</div>
          <div class="numhidden">中国服务企业500强</div>
        </div>
        <div class="homepage-number-item-line"></div>
        <div class="homepage-number-item">
          <div class="num">百亿量级</div>
          <div class="numhidden">年销售额</div>
        </div>
        <div class="homepage-number-item-line"></div>
        <div class="homepage-number-item">
          <div class="num">4000W+</div>
          <div class="numhidden">数字会员</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
